import React from 'react'
import Youtube from 'react-youtube'

const YouTubeVideo = () => {
  const videoId = 'hnb3gM11Q0I'
  const opts = {
    width: '100%',
    height: '100%',
    playerVars: {
      playsinline: 0,
      // autoplay: 1,
      loop: 1,
      rel: 0,
    },
  }

  return (
    <div className="mx-auto flex  justify-center   pt-0 lg:w-3/5 xl:py-3 ">
      <Youtube
        videoId={videoId}
        opts={opts}
        className="aspect-video  w-full   shadow-md "
      />
    </div>
  )
}

export default YouTubeVideo
